import { Injectable } from "@angular/core";
import { NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { BackupDevicesFilter } from "./tabs/backup-devices-tab/backup-devices-tab.model";
import { BackupJobData, JobExecutionStatus, JobType, SchedulerJob } from "@nms-ng2/app/modules/scheduler/scheduler.models";
import { BackupDevicesScheduler } from "./tabs/backup-scheduler-tab/backup-scheduler-tab.model";
import { BackupDevicesGeneral } from "./tabs/backup-general-tab/backup-general-tab.model";
import { SchedulerService } from "@nms-ng2/app/modules/scheduler/scheduler.service";

/**
 * Serviço utilitário para criação/edição de Backups de Equipamento.
 */
@Injectable({
    providedIn: "root"
})
export class CreateBackupService {

    constructor(private schedulerService: SchedulerService) { }

    buildDeviceBackupScheduler(wizardStepsCacheMap: NmsWizardStepMapData): SchedulerJob {
        const schedulerJob: SchedulerJob = this.schedulerService.initSchedulerJob(null, JobType.BACKUP);
        const backupJobData: BackupJobData = schedulerJob.jobData as BackupJobData;

         const backupDevicesFilter   = wizardStepsCacheMap["BackupDevicesFilter"]    as BackupDevicesFilter;
         const backupSchedulerFilter = wizardStepsCacheMap["BackupDevicesScheduler"] as BackupDevicesScheduler;
         const backupGeneralFilter   = wizardStepsCacheMap["BackupDevicesGeneral"]   as BackupDevicesGeneral;

         schedulerJob.type     = backupSchedulerFilter?.jobType;
         schedulerJob.triggers = backupSchedulerFilter?.triggers;
         schedulerJob.id       = backupSchedulerFilter?.id;
         schedulerJob.name     = backupGeneralFilter?.name;
         schedulerJob.enabled  = backupGeneralFilter?.enabled;
         schedulerJob.status   = backupGeneralFilter?.status || JobExecutionStatus.NOT_REQUESTED;

         backupJobData.devicesFilter = backupDevicesFilter.devicesFilter;
         backupJobData.description   = backupGeneralFilter?.description;
         backupJobData.exportBackups = backupGeneralFilter?.exportBackups;

         return schedulerJob;
    }
}
